/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Preview_Magnify_TitleInputs */

const en_image_export_preview_magnify_title = /** @type {(inputs: Image_Export_Preview_Magnify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magnify Preview`)
};

const fr_image_export_preview_magnify_title = /** @type {(inputs: Image_Export_Preview_Magnify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agrandir la previsualisation`)
};

const de_image_export_preview_magnify_title = /** @type {(inputs: Image_Export_Preview_Magnify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschau vergrößern`)
};

const it_image_export_preview_magnify_title = /** @type {(inputs: Image_Export_Preview_Magnify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingrandisci Anteprima`)
};

const ru_image_export_preview_magnify_title = /** @type {(inputs: Image_Export_Preview_Magnify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увеличить Предварительный просмотр`)
};

const es_image_export_preview_magnify_title = /** @type {(inputs: Image_Export_Preview_Magnify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ampliar vista previa`)
};

const zh_cn2_image_export_preview_magnify_title = /** @type {(inputs: Image_Export_Preview_Magnify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`放大预览`)
};

const ja_image_export_preview_magnify_title = /** @type {(inputs: Image_Export_Preview_Magnify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拡大プレビュー`)
};

const hi_image_export_preview_magnify_title = /** @type {(inputs: Image_Export_Preview_Magnify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ज़ूम करके पूर्वावलोकन देखें`)
};

const pt_pt2_image_export_preview_magnify_title = /** @type {(inputs: Image_Export_Preview_Magnify_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ampliar pré-visualização`)
};

/**
* | output |
* | --- |
* | "Magnify Preview" |
*
* @param {Image_Export_Preview_Magnify_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_preview_magnify_title = /** @type {((inputs?: Image_Export_Preview_Magnify_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Preview_Magnify_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_preview_magnify_title(inputs)
	if (locale === "de") return de_image_export_preview_magnify_title(inputs)
	if (locale === "it") return it_image_export_preview_magnify_title(inputs)
	if (locale === "ru") return ru_image_export_preview_magnify_title(inputs)
	if (locale === "es") return es_image_export_preview_magnify_title(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_preview_magnify_title(inputs)
	if (locale === "ja") return ja_image_export_preview_magnify_title(inputs)
	if (locale === "hi") return hi_image_export_preview_magnify_title(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_preview_magnify_title(inputs)
	return en_image_export_preview_magnify_title(inputs)
});